export default "__VITE_ASSET__ca174069__"